import HeaderMUN from "../Component/HeaderMUN";
import FooterMun from "../Component/FooterMun";
import MunGallery from "../Component/MunGallery";
import MunCommittees from "../utils/MunCommittees";
import { munCommitteeData } from "../utils/MunCommitteeTestimonial";
import MunDelegatesInst from "./MunDelegatesInst";

const S3_url = "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com";

const NcsMun = () => {
  const committees = munCommitteeData;

  const introText = [
    "NCS MUN provides students with an opportunity to engage with the issues shaping our world while developing the confidence to articulate their perspectives. Through committee sessions, negotiations, and collaborative problem-solving, delegates learn to analyse complex challenges, defend their positions with evidence, and work towards practical solutions.",
    "Following the strong foundation laid by our intra-school conferences, NCS MUN 2026-27 now welcomes participation from schools beyond our campus, creating a broader forum for dialogue and exchange. The conference encourages girl students from Grades 9-12 to examine matters of international significance alongside concerns that affect our nation and local communities.",
    "More than a simulation, NCS MUN is a learning experience that nurtures awareness, empathy, and responsible leadership. We aspire to empower young women who are informed, empathetic, thoughtful in their actions, and committed to making a meaningful difference in the world around them.",
  ];

  return (
    <>
      <HeaderMUN />

      <img
        src={`${S3_url}/NCSR/public/Images/breadcrumb_mun.jpeg`}
        alt="NCS MUN breadcrumb"
        className="img-fluid w-100 h-100 object-fit-cover"
      />
      <div className="mun-highlight-marquee">
        <marquee behavior="scroll" direction="left" scrollamount="6">
          Upcoming Event: Inter-School NCS MUN | 17th &amp; 18th July 2026
        </marquee>
      </div>
      <div className="innerPage mun_ncs-block">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="mun-intro-head">
                <h3>About NCS MUN</h3>
              </div>

              <div className="mun-intro-copy">
                {introText.map((text, index) => (
                  <p key={index}>{text}</p>
                ))}
              </div>
            </div>

            <div className="row message_Container">
              <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                <div className="mun-principal-invitation" id="principal-invitation">
                  <div className="mun-heads-image">
                    <img
                      src={`${S3_url}/NCSR/public/Images/ncs_mun_principal.png`}
                      alt="NCS MUN Principal"
                      className="mun-heads-img"
                    />
                  </div>
                  <h3>Principal’s Message</h3>
                  <div className="message_mun">
                    <p>Dear Delegates,</p>
                    <p>
                      It gives me great joy to welcome you to Nirmala Convent School,
                      Rajkot, for our first inter-school Model United Nations. Building
                      on the success of our intra-school MUNs, this expanded platform
                      reflects our commitment to learning beyond the classroom, and
                      encouraging research, reasoned debate, confident public speaking,
                      and respectful collaboration to prepare students for leadership and
                      responsible citizenship.
                    </p>
                    <p>
                      This conference is especially meaningful as it creates space for
                      young women to lead and represent themselves with strength and
                      dignity. I encourage every delegate to engage actively, listen with
                      grace, and contribute sincerely throughout the event. Best wishes
                      to all delegates, organizers, and mentors for a productive and
                      inspiring MUN.
                    </p>
                  </div>
                  <div className="designation_mun">
                    <p>
                      With warm regards,
                      <br />
                      <strong>Sr. Betty Mathew</strong>
                      <br />
                      Principal, Nirmala Convent School, Rajkot
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                <div className="mun-principal-invitation" id="committee-heads-message">
                  <div className="mun-heads-image">
                    <img
                      src={`${S3_url}/NCSR/public/Images/mun_committe_img.png`}
                      alt="Committee Heads"
                      className="mun-heads-img"
                    />
                  </div>
                  <h3>Committee Heads’ Message</h3>
                  <div className="message_mun">
                    <p>Dear Delegates,</p>
                    <p>
                      NCS MUN 2026-27 offers a unique platform where preparation meets
                      performance. It is more than an academic exercise; it prepares you
                      for future opportunities and responsibilities by teaching
                      discipline, punctuality, professionalism, and respectful conduct.
                      These are the qualities that matter in every field.
                    </p>
                    <p>
                      The skills you gain here will stay with you beyond these two days,
                      strengthening your applications, leadership prospects, and careers.
                      Approach the conference with commitment and curiosity, and let it
                      be the start of many opportunities to represent your ideas with
                      confidence and purpose.
                    </p>
                  </div>
                  <div className="designation_mun">
                    <p>
                      With best wishes for a rewarding conference,
                      <br />
                      <strong>Dr. Rashmi Gandhi & Ms. Punam Sharma</strong>
                      <br />
                      Committee Heads - NCS MUN 2026-27
                      <br />
                      Nirmala Convent School, Rajkot
                    </p>
                  </div>
                </div>
              </div>
            </div>
     <div className="col-12">
              <div className="mun-section-head">
                <h3>General Instructions for Delegates</h3>
              </div>
              <div className="mun_ncs-block">
                <MunDelegatesInst />
              </div>
            </div>
            <div className="col-12" id="committees">
              <div className="mun-section-head">
                <h3>Explore Committees 2026</h3>
              </div>
              <MunCommittees committees={committees} />
            </div>

            <div className="col-12" id="previous-muns">
              <div className="mun-section-head">
                <h3>Previous MUNs</h3>
              </div>
              <MunGallery />
            </div>

       
          </div>
        </div>
      </div>

      <FooterMun />
    </>
  );
};

export default NcsMun;
